var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4925 10.9425C14.3811 11.7894 13.9651 12.5668 13.3224 13.1294C12.6797 13.6921 11.8542 14.0015 11 14C6.03751 14 2.00001 9.9625 2.00001 5C1.99847 4.14581 2.30794 3.32027 2.87059 2.67756C3.43324 2.03486 4.21061 1.61894 5.05751 1.5075C5.27166 1.48135 5.48854 1.52517 5.67575 1.6324C5.86296 1.73964 6.01047 1.90454 6.09626 2.1025L7.41626 5.04938V5.05688C7.48194 5.20841 7.50906 5.37385 7.49521 5.53843C7.48136 5.703 7.42696 5.86158 7.33688 6C7.32563 6.01688 7.31376 6.0325 7.30126 6.04813L6.00001 7.59063C6.46813 8.54188 7.46313 9.52813 8.42688 9.9975L9.94813 8.70313C9.96307 8.69057 9.97872 8.67888 9.99501 8.66813C10.1333 8.57588 10.2924 8.51957 10.458 8.50429C10.6235 8.48901 10.7903 8.51525 10.9431 8.58063L10.9513 8.58438L13.8956 9.90375C14.0939 9.98924 14.2592 10.1366 14.3668 10.3239C14.4744 10.5111 14.5185 10.7281 14.4925 10.9425Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneicon);
export default __webpack_public_path__ + "static/media/phone.icon.1495cd9825cf56494f96589376af4671.svg";
export { ForwardRef as ReactComponent };